module.exports = __webpack_public_path__ + "img/finland-external-causes-female.765fdc56.png";